import React, { Fragment } from 'react'
import { Typography } from '@mui/material'
import { Field, Fields } from 'redux-form'
import { hasString, hasArray } from './helpers'
import { muiLookupComponent } from './MuiBuyflowHelpers'
import { evaluateConditions } from './evaluateConditions'
import evaluate from '../../utility/evaluate'
export function MuiSchemaQuestions ({
  sections,
  currentValues,
  renderPropsFactory = obj => obj,
  prefix = '',
  useEvaluate = false,
  sectionClassName = 'section--block',
  SectionTag = 'div',
  sectionConfig = SectionTag === 'div'
    ? {
      className: sectionClassName
    }
    : {},
  showSectionTitles = true
}) {
  const conditionsHandler = useEvaluate
    ? ({ condition }) =>
      condition ? evaluate(condition, currentValues, prefix) : true
    : evaluateConditions({ currentValues })
  return (
    <Fragment>
      {sections.filter(conditionsHandler).map((section, sIndex) => (
        <SectionTag {...sectionConfig} key={`section.${sIndex}`}>
          {showSectionTitles &&
            hasString(section.title) && (
            <div className='section--title'>
              <Typography variant='h5' color='secondary' style={{ fontWeight: 500 }} className='schema-question-title'>
                {section.title}
              </Typography>
            </div>
          )}
          {hasString(section.pretext) && (
            <div className='section--pretext'>
              <Typography variant='body1' style={{ fontWeight: 500 }} className='schema-question-pretext'>
                {section.pretext}
              </Typography>
            </div>
          )}
          {hasArray(section.fields) &&
            section.fields.map((fieldConfig, fIndex) => {
              if (!conditionsHandler(fieldConfig)) {
                return null
              }

              const { component, ...field } = fieldConfig
              const fieldCopy = Object.assign({}, field)
              if (Array.isArray(field.data)) {
                fieldCopy.data = field.data.filter(conditionsHandler)
              }
              const key = `section.${sIndex}.field.${fIndex}`
              let FormComponent = Field
              let RenderComponent = muiLookupComponent(component)
              let renderProps = {}
              if (component === 'MultiselectField') {
                FormComponent = Fields
                renderProps = {
                  names: fieldCopy.data.map(
                    ({ value }) => `${fieldCopy.name}.${value}`
                  )
                }
              } else if (component === 'RadioGroupField') {
                RenderComponent = muiLookupComponent('RadioGroupField')
                renderProps = {
                  horizontal: fieldCopy.data.length <= 2
                }
              } else if (component === 'TextareaField') {
                RenderComponent = muiLookupComponent('TextareaField')
                if (fieldConfig.fullWidth) {
                  renderProps = {
                    className: 'form__field--max-width'
                  }
                }
              }

              if (fieldConfig.style) {
                renderProps = { ...renderProps, style: fieldConfig.style }
              }
              return (
                <FormComponent
                  key={key}
                  {...renderPropsFactory({ ...renderProps, ...fieldCopy })}
                  component={RenderComponent}
                />
              )
            })}
        </SectionTag>
      ))}
    </Fragment>
  )
}
